export default __webpack_public_path__ + "static/media/Gerb.da0487ff.svg";